import { Component, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { Observable, of, Subject, Subscription } from 'rxjs';
import { ViewDataService, WCupSeasonItem } from 'world-archery-lib';
import { BaseFiltersComponent } from '../../shared/base-filters.component';
import { FiltersServiceService } from '../filters-service.service';

@Component({
  selector: 'app-filters-indoor',
  templateUrl: './filters-indoor.component.html',
  styleUrls: ['./filters-indoor.component.css']
})
export class FiltersIndoorComponent {
  constructor(public filter_service: FiltersServiceService) {
  }
}
